// extracted by mini-css-extract-plugin
export default {"accessRightIndicator":"institutionCard_accessRightIndicator__cx5RG"};